var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpringBoot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.205 16.392c-2.469 3.289-7.741 2.179-11.122 2.338 0 0-.599.034-1.201.133 0 0 .228-.097.519-.198 2.374-.821 3.496-.986 4.939-1.727 2.71-1.388 5.408-4.413 5.957-7.555-1.032 3.022-4.17 5.623-7.027 6.679-1.955.722-5.492 1.424-5.493 1.424.002.002-.141-.074-.143-.076-2.405-1.17-2.475-6.38 1.894-8.059 1.916-.736 3.747-.332 5.818-.825 2.208-.525 4.766-2.18 5.805-4.344 1.165 3.458 2.565 8.866.054 12.21zm.042-13.28c-.293.698-.652 1.327-1.065 1.89-1.819-1.867-4.359-3.031-7.167-3.031-5.523 0-10.015 4.492-10.015 10.014 0 2.895 1.235 5.505 3.205 7.334l.22.194c-.366-.298-.423-.836-.126-1.203.299-.367.837-.423 1.203-.126.367.298.424.837.126 1.204-.296.367-.835.423-1.202.126l.149.132c1.742 1.468 3.988 2.354 6.44 2.354 5.278 0 9.613-4.108 9.984-9.292.274-2.539-.476-5.763-1.752-9.596"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpringBoot);
export default __webpack_public_path__ + "static/media/spring-boot.c257b61a94a81ab50ccfe33bd9d5eeed.svg";
export { ForwardRef as ReactComponent };